import React, { useState } from 'react'
import { postverificarYEliminarUnProcedimientoNoOperacional } from '../../../services/Contratacion'
import { set } from 'react-hook-form'
import ModalMensajeProcedimientosNoOperacionales from './ModalMensajeProcedimientosNoOperacionales'

const ModalEliminarProcedimientosNoOperacionales = ({setmodalOnEliminarProcedimientosNoOperacionales, dataUnProcedimientoNoOperacional, setactualizarDataProcedimientosNoOperacionales}) => {
    const [loading, setloading]=useState(true)
    const [mensajeError, setmensajeError]=useState('')
    const [modalOnErrorEliminar, setModalOnMensajeError]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnEliminarProcedimientosNoOperacionales(false)
    }
    const handleOnClickEliminar=()=>{
        const dataEliminar={
          'PRCODI': dataUnProcedimientoNoOperacional.PRCODI
        }
        setloading(false)
        postverificarYEliminarUnProcedimientoNoOperacional(dataEliminar).then(response=>{
          console.log(response.data, 'delete')
          setloading(true)
          if(response.data.success){
            setactualizarDataProcedimientosNoOperacionales(dataEliminar)
            setmodalOnEliminarProcedimientosNoOperacionales(false)
          }else{
            console.log(response.data, 'delete')
            setmensajeError(response.data.message)
            setModalOnMensajeError(true)
          }
        })
          
          
    };
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-red-400">
          <h5
            className="text-xl font-medium leading-normal text-white"
            id="exampleModalScrollableLabel"
          >
            Mensaje
          </h5>
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative p-4">
          <div className="flex py-2 text-left">
            <div className="w-3/3  px-4">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Esta seguro de eliminar el procedimiento no operacional {dataUnProcedimientoNoOperacional.PRCODI}-{dataUnProcedimientoNoOperacional.PrNomb}  ?
              </label>
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button
            type="button"
            onClick={handleOnClickEliminar}
            className="inline-block px-6 py-2.5 ml-3 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Eliminar
          </button>
          
          
        </div>
      </div>
    </div>
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }   
    {modalOnErrorEliminar? <ModalMensajeProcedimientosNoOperacionales mensajeError={mensajeError} setModalOnMensajeError={setModalOnMensajeError}/>:null}
    {/* {modalOnErrorEiminar? <ModalErrorEliminarMaestroProcedimiento setmodalOnErrorEiminar={setmodalOnErrorEiminar} mensajeError={mensajeError}/>:null} */}
    {/* {modalOnEliminoCorrectamente? <ModalEliminoCorrectamenteMaestroProcedimiento setmodalOnEliminoCorrectamente={setmodalOnEliminoCorrectamente} setmodalOnEliminar={setmodalOnEliminar}/>:null} */}
  </div>
  )
}

export default ModalEliminarProcedimientosNoOperacionales